import { createContext, useContext } from "react";
import type SafeAppsSDK from "@safe-global/safe-apps-sdk";
import type { SafeInfo } from "@safe-global/safe-apps-sdk";
import type { BrowserProvider, JsonRpcProvider } from "ethers";

import type { AppRunMode, RuntimeState } from "@/safe/runtimePolicy";

export type EthersProvider = BrowserProvider | JsonRpcProvider;

export type SafeConnection = {
  mode: AppRunMode;
  connected: boolean;
  safe?: SafeInfo;
  sdk?: SafeAppsSDK;

  /**
   * Ethers Provider:
   * - IN_SAFE: BrowserProvider wrapping SafeAppsProvider (EIP-1193)
   * - OUTSIDE_SAFE: JsonRpcProvider (read-only) if configured
   */
  provider?: EthersProvider;

  /**
   * If OUTSIDE_SAFE and no RPC is configured, provider is undefined.
   */
  providerStatus: "ready" | "missing-rpc" | "unavailable";

  /**
   * Explicit runtime mode/capability model used for route and write gating.
   */
  runtime: RuntimeState;
};

export const SafeContext = createContext<SafeConnection | undefined>(undefined);

export function useSafe(): SafeConnection {
  const ctx = useContext(SafeContext);
  if (!ctx) throw new Error("useSafe must be used within SafeProvider");
  return ctx;
}
